import React from "react";

function Data() {
  return (
    <div className="home_data">
      <h1 className="home_title">
        Abhishek Jha<span className="hand">🖐️</span>
      </h1>
      <h3 className="sub_title">Full Stack Developer</h3>
      <p className="home_discri">
        I'm Learning MERN Stack, I'm very passionate and dedicated to my work
      </p>

      <div className="hello">
        <a href="">Say Hello</a>
        <i className="fa-regular fa-hand"></i>
      </div>
    </div>
  );
}

export default Data;
